import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { moduleActions } from '../../../redux/modules';

import './QCDSteps.scss';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import If from '../../Shared/If/If';
import AppTitle from '../../Shared/AppTitle/AppTitle';
import ProgressStep from '../../ProgressStep/ProgressStep';
import {
  CANCEL_TRADE_CONFIRMATION_MODAL,
  openModal,
} from 'src/redux/modules/modals/modals.module';
import {
  getCharitiesTotalGrossAmount,
  getCheckbox,
  getEligibleQCDFundsTotalAmount,
  getSelectedQCDFundsHaveRedemption,
  getCharitiesArray,
  getCharitiesEveryCharityGrossAmountAboveOne,
  getSubmissionPayload,
  getQCDLoading,
  getEligibleQCDFundsList,
} from '../../../redux/modules/qcd/qcd.selectors';

import {
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { getIsStep1NextButtonDisabled } from '../../../redux/modules/sellTransaction/sellTransaction.selectors';
import { getProgressCurrentStep } from '../../../redux/modules/progress/selectors';
import { analyticsDataLayer } from '../../../redux/utils/analytics-helper';
import DeliveryMethodForm from '../../Sell/DeliveryMethodForm/DeliveryMethodForm';
import DeliveryMethodChosen from '../../Sell/DeliveryMethodChosen/DeliveryMethodChosen';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import CharityAmount from '../step2/CharityAmount';
import EditLine from '../EditLine/EditLine';
import QCDFundsList from '../step3/QCDFundsList';
import Disclosure from '../QCDLanding/Disclosure';
import {
  executeQCD,
  getEligibleQcdTradeDates,
} from '../../../redux/modules/qcd/qcd.module';

export const QCDSteps = () => {
  const isIFrame = useSelector(isEmbeddedInIFrame);
  const salesforceRep = useSelector(isSalesforceRep);
  const customerWebViewEnabled = useSelector(isCustomerWebViewEnabled);
  const dispatch = useDispatch();
  const isStep1NextButtonDisabled = useSelector(getIsStep1NextButtonDisabled);
  const userEnteredCharities = useSelector(getCharitiesArray);
  const currentStep = useSelector(getProgressCurrentStep);
  const isChecked = useSelector(getCheckbox);
  const istotalCharityAmountDisabled = useSelector(
    getCharitiesEveryCharityGrossAmountAboveOne
  );
  const allFundsHaveRedemption = useSelector(getSelectedQCDFundsHaveRedemption);
  const totalCharityAmount = useSelector(getCharitiesTotalGrossAmount);
  const totalGrossAmountAgreements = useSelector(
    getEligibleQCDFundsTotalAmount
  );
  const submitPayload = useSelector(getSubmissionPayload);
  const executeQCDLoading = useSelector(getQCDLoading);
  const qcdFunds = useSelector(getEligibleQCDFundsList);
  const { qcdTradeDatesLoading } = useSelector(
    (state) => state.executePurchase
  );

  const [step2Edit, setStep2Edit] = useState(false);
  const [step3Edit, setStep3Edit] = useState(false);
  useEffect(() => {
    const { loadApplication, setAppLoading } = moduleActions;
    dispatch(setAppLoading());
    analyticsDataLayer();
    dispatch(loadApplication(moduleActions));
  }, [dispatch]);

  function onClickScroll(step, element) {
    dispatch(moduleActions.setProgress(step));
    scrollElementIntoFullView(element, 15);
  }

  function doSubmit() {
    onClickScroll(5, 'qcd-page-container');
    try {
      analyticsDataLayer({
        amount: submitPayload?.distribution?.totalDistributionAmount,
        quantity: 1,
      });
    } catch (e) {
      // don't let analytics errors cause other things to fail
    }
    dispatch(executeQCD(submitPayload));
  }

  function handleSubmitTradeDate() {
    Promise.all([dispatch(getEligibleQcdTradeDates(submitPayload))]).then(
      () => {
        setStep3Edit(true);
        onClickScroll(4, 'funding-target-step');
      }
    );
  }

  const fundingTargetStep = 'funding-target-step';
  return (
    <div id="qcd-page-container">
      {/* <If test={!(isIFrame || (!customerWebViewEnabled && isSalesforceRep))}> */}
      <StepsPageBackground />
      {/* </If> */}
      <div className="container">
        <form
          onSubmit={(e) => e.preventDefault()}
          className="animated fadeInUp"
        >
          <If test={!(isIFrame || (!customerWebViewEnabled && salesforceRep))}>
            <AppTitle
              title="Make a Qualified Charitable Distribution"
              subtitle={
                <div>
                  Make a nontaxable donation to an eligible charity of your
                  choice. This may count toward satisfying your required minimum
                  distribution.
                </div>
              }
              mboxTitle="ret-aa-new-mf-qcd-title"
              mboxSubtitle="ret-aa-new-mf-qcd-subtitle"
            />
          </If>

          <ProgressStep
            title={<span> Choose your delivery method and charity </span>}
            className={fundingTargetStep}
            clickable={currentStep > 1}
            step={1}
            active={currentStep === 1}
            complete={currentStep > 1}
            OnClickHeader={() => {
              currentStep > 1 && onClickScroll(1, fundingTargetStep);
            }}
            expanded
            nextButtonLabel={<span>Select Charity Amounts</span>}
            nextButtonDisabled={
              isStep1NextButtonDisabled || userEnteredCharities.length === 0
            }
            onNextClick={() => {
              setStep2Edit(true);
              onClickScroll(2, fundingTargetStep);
            }}
            showCancelLink={!(!customerWebViewEnabled && salesforceRep)}
            onCancelClick={() =>
              dispatch(openModal(CANCEL_TRADE_CONFIRMATION_MODAL))
            }
          >
            {currentStep === 1 ? (
              <DeliveryMethodForm />
            ) : (
              <DeliveryMethodChosen
                onEditClick={() => {
                  onClickScroll(1, fundingTargetStep);
                }}
              />
            )}
          </ProgressStep>
          <ProgressStep
            title={<span>Select your charity amounts</span>}
            className={fundingTargetStep}
            clickable={currentStep > 2}
            step={2}
            active={currentStep === 2}
            complete={currentStep > 2}
            OnClickHeader={() => {
              currentStep > 2 && onClickScroll(2, fundingTargetStep);
            }}
            expanded
            nextButtonLabel={<span>Select Fund(s) & Amounts</span>}
            nextButtonDisabled={!istotalCharityAmountDisabled}
            onNextClick={() => {
              onClickScroll(3, fundingTargetStep);
            }}
            showCancelLink={!(!customerWebViewEnabled && salesforceRep)}
            onCancelClick={() =>
              dispatch(openModal(CANCEL_TRADE_CONFIRMATION_MODAL))
            }
          >
            {currentStep === 2 ? (
              <CharityAmount />
            ) : (
              <EditLine
                onEditClick={() => {
                  onClickScroll(2, fundingTargetStep);
                }}
                step={2}
                totalGrossAmount={totalCharityAmount || 0}
                step2Edit={step2Edit && totalCharityAmount > 0}
              />
            )}
          </ProgressStep>
          <ProgressStep
            title={<span> Select your funds and distribution amounts </span>}
            className={fundingTargetStep}
            clickable={currentStep > 3}
            step={3}
            active={currentStep === 3}
            complete={currentStep > 3}
            OnClickHeader={() => {
              currentStep > 3 && onClickScroll(3, fundingTargetStep);
            }}
            expanded
            nextButtonLabel={<span>Review & Submit</span>}
            nextButtonDisabled={
              qcdFunds.some(
                (fund) => fund.QCDgrossAmountError && fund.selected
              ) ||
              totalGrossAmountAgreements !== totalCharityAmount ||
              !allFundsHaveRedemption
            }
            onNextClick={() => {
              handleSubmitTradeDate();
            }}
            nextButtonLoading={qcdTradeDatesLoading}
            showCancelLink={!(!customerWebViewEnabled && salesforceRep)}
            onCancelClick={() =>
              dispatch(openModal(CANCEL_TRADE_CONFIRMATION_MODAL))
            }
          >
            {currentStep === 3 ? (
              <QCDFundsList
                actions={moduleActions}
                isSalesforceRep={isSalesforceRep}
                customerWebViewEnabled={customerWebViewEnabled}
              />
            ) : (
              <EditLine
                onEditClick={() => {
                  onClickScroll(3, fundingTargetStep);
                }}
                step={3}
                totalGrossAmount={totalCharityAmount || 0}
                step3Edit={step3Edit && totalCharityAmount > 0}
              />
            )}
          </ProgressStep>
          <ProgressStep
            title={<span> Review and submit your QCD </span>}
            className={fundingTargetStep}
            clickable={currentStep > 4}
            step={4}
            active={currentStep === 4}
            complete={currentStep > 4}
            OnClickHeader={() => {
              currentStep > 4 && onClickScroll(4, fundingTargetStep);
            }}
            expanded
            nextButtonLabel={<span>Submit</span>}
            nextButtonDisabled={
              !isChecked || customerWebViewEnabled || executeQCDLoading
            }
            // TODO: update onNextClick destination
            onNextClick={() => {
              doSubmit();
            }}
            showCancelLink={!(!customerWebViewEnabled && salesforceRep)}
            onCancelClick={() =>
              dispatch(openModal(CANCEL_TRADE_CONFIRMATION_MODAL))
            }
          >
            {currentStep === 4 ? <Disclosure /> : <></>}
          </ProgressStep>
        </form>
      </div>
    </div>
  );
};

export default QCDSteps;
